var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-text"},[_c('a',{attrs:{"href":_vm.getSource,"target":"_blank"}},[_vm._v("One Tab View")]),_c('pmca-element',{attrs:{"id":_vm.buildId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }